/* Manu AI v14 (21/10/2026) — « Reprendre » : historique local des créations.
 * - Chaque création (devant / dos + positions + contexte de la conversation) est rangée dans IndexedDB, sur l'ordinateur
 *   du visiteur (base « rxManuHistory », 8 créations max, rien n'est envoyé nulle part).
 * - À l'ouverture de Manu (accueil vide, lien /?manu=1, icône flottante), les dernières créations sont proposées :
 *   un clic rouvre le résultat, modifiable, sans consommer de création offerte.
 * - Drapeau localStorage rxManuHas : lu par l'icône flottante (snippets/rx-manu-launcher.liquid) pour signaler l'historique.
 * S'appuie sur l'instance de assets/ai-studio.js (section._ais), enrichie par v9 → v13, chargés avant. */
(function () {
  'use strict';

  var DB = 'rxManuHistory', ST = 'designs', MAX = 8;
  var TXT = {
    fr: { title: 'Reprendre une création', clear: 'Effacer mon historique', untitled: 'Création du {d}' },
    en: { title: 'Pick up a design', clear: 'Clear my history', untitled: 'Design of {d}' },
    es: { title: 'Retomar un diseño', clear: 'Borrar mi historial', untitled: 'Diseño del {d}' },
    de: { title: 'Entwurf fortsetzen', clear: 'Meinen Verlauf löschen', untitled: 'Entwurf vom {d}' },
    it: { title: 'Riprendi un design', clear: 'Cancella la cronologia', untitled: 'Design del {d}' }
  };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function tt(loc) { return TXT[loc] || TXT.fr; }
  function dateOf(at, loc) { try { return new Date(at).toLocaleDateString(loc, { day: 'numeric', month: 'short' }); } catch (e) { return ''; } }
  function flag(on) { try { if (on) localStorage.setItem('rxManuHas', '1'); else localStorage.removeItem('rxManuHas'); } catch (e) {} }

  /* ---------- IndexedDB (promesses minimales) ---------- */
  function openDb() {
    return new Promise(function (res, rej) {
      if (!window.indexedDB) { rej(new Error('no-idb')); return; }
      var r = indexedDB.open(DB, 1);
      r.onupgradeneeded = function () { r.result.createObjectStore(ST, { keyPath: 'id' }); };
      r.onsuccess = function () { res(r.result); };
      r.onerror = function () { rej(r.error); };
    });
  }
  function run(mode, fn) {
    return openDb().then(function (db) {
      return new Promise(function (res, rej) {
        var t = db.transaction(ST, mode), req = fn(t.objectStore(ST));
        t.oncomplete = function () { db.close(); res(req ? req.result : undefined); };
        t.onerror = t.onabort = function () { db.close(); rej(t.error); };
      });
    });
  }
  function list() { return run('readonly', function (st) { return st.getAll(); }).then(function (a) { return (a || []).sort(function (x, y) { return y.at - x.at; }); }); }
  function get(id) { return run('readonly', function (st) { return st.get(id); }); }
  function put(rec) { return run('readwrite', function (st) { return st.put(rec); }); }
  function clearAll() { return run('readwrite', function (st) { return st.clear(); }); }
  function prune() {
    return list().then(function (a) {
      if (a.length <= MAX) return;
      return run('readwrite', function (st) { a.slice(MAX).forEach(function (r) { st.delete(r.id); }); });
    });
  }

  /* ---------- Instantané d'une création ---------- */
  function cleanFace(f) {
    if (!f || f.mock) return null;
    var o = {};
    Object.keys(f).forEach(function (k) {
      var v = f[k];
      if (v == null || typeof v === 'function' || (typeof v === 'object' && v.nodeType)) return;
      o[k] = v;
    });
    return o;
  }
  function thumbOf(faces) {
    var f = faces.front || faces.back, src = f && (f.view || f.raw || f.src);
    if (!src) return Promise.resolve(null);
    return new Promise(function (res) {
      var i = new Image();
      i.onload = function () {
        var w = i.naturalWidth || 160, h = i.naturalHeight || 160, k = Math.min(1, 160 / Math.max(w, h)), c = document.createElement('canvas');
        c.width = Math.max(1, Math.round(w * k)); c.height = Math.max(1, Math.round(h * k));
        try { c.getContext('2d').drawImage(i, 0, 0, c.width, c.height); res(c.toDataURL('image/png')); } catch (e) { res(null); }
      };
      i.onerror = function () { res(null); };
      i.src = src;
    });
  }
  function snapshot(inst) {
    var s = inst.s;
    if (!s || !s.faces) return null;
    var faces = { front: cleanFace(s.faces.front), back: cleanFace(s.faces.back) };
    if (!faces.front && !faces.back) return null;
    if (!s.saveId) s.saveId = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    return {
      id: s.saveId, at: Date.now(), loc: inst.loc, idea: String(s.idea || '').slice(0, 200),
      sport: s.sport || null, niche: s.niche || null, style: s.style || null, logoText: s.logoText || null, sides: s.sides || null, frontFmt: s.frontFmt || null, noText: !!s.noText,
      faces: faces, pos: JSON.parse(JSON.stringify(s.pos || {})), edit: s.edit || (faces.front ? 'front' : 'back'),
      history: JSON.parse(JSON.stringify((s.history || []).slice(-10)))
    };
  }

  function enhance(root) {
    var inst = root._ais;
    if (!inst || inst._v14) return;
    inst._v14 = true;

    inst.saveDesign = function () {
      var rec = snapshot(this);
      if (!rec) return Promise.resolve();
      return thumbOf(rec.faces).then(function (th) {
        rec.thumb = th;
        return put(rec);
      }).then(function () { flag(true); return prune(); }).catch(function () {});
    };

    // Une création est rangée dès qu'elle est affichée, puis à la fermeture (positions / tailles modifiées)
    var showResult = inst.showResult;
    inst.showResult = function () {
      var r = showResult.apply(this, arguments);
      this.saveDesign();
      return r;
    };
    inst.dialog.addEventListener('close', function () { inst.saveDesign(); });

    // Accueil de Manu : après les réponses rapides, les dernières créations
    var welcome = inst.welcome, chips = inst.chips;
    inst.welcome = function () {
      var r = welcome.apply(this, arguments);
      this._wantResume = this.run;
      return r;
    };
    inst.chips = function () {
      var r = chips.apply(this, arguments);
      if (this._wantResume && this._wantResume === this.run) { this._wantResume = 0; this.resumeBlock(); }
      return r;
    };

    inst.resumeBlock = function () {
      var self = this, runId = this.run, T = tt(this.loc);
      list().then(function (items) {
        if (!items.length || runId !== self.run) return null;
        var html = '<div class="ais-resume"><p class="ais-resume__t">' + esc(T.title) + '</p><ul class="ais-resume__list">' +
          items.slice(0, 4).map(function (r) {
            var name = r.idea || T.untitled.replace('{d}', dateOf(r.at, self.loc));
            return '<li><button type="button" class="ais-resume__it" data-resume="' + esc(r.id) + '">' +
              (r.thumb ? '<img src="' + esc(r.thumb) + '" alt="" width="44" height="44">' : '<span class="ais-resume__ph" aria-hidden="true"></span>') +
              '<span class="ais-resume__txt"><b>' + esc(name) + '</b><small>' + esc(dateOf(r.at, self.loc)) + '</small></span></button></li>';
          }).join('') + '</ul><button type="button" class="ais-resume__clear" data-resume-clear>' + esc(T.clear) + '</button></div>';
        return self.bot(html, true);
      }).then(function (el) {
        if (!el) return;
        el.addEventListener('click', function (e) {
          var b = e.target.closest('[data-resume]'), c = e.target.closest('[data-resume-clear]');
          if (b) self.resume(b.getAttribute('data-resume'));
          else if (c) clearAll().then(function () { flag(false); el.remove(); }, function () {});
        });
      }).catch(function () {});
    };

    // Lien /?manu=back (bandeau de la fiche produit) : rouvre directement la dernière création, sinon l'accueil de Manu
    inst.resumeLast = function () {
      return list().then(function (items) { return items && items[0] ? inst.resume(items[0].id) : inst.welcome(); }).catch(function () {});
    };
    if (/[?&]manu=back\b/.test(location.search)) setTimeout(function () { if (!inst.dialog.open) inst.resumeLast(); }, 120);

    // Rouvre une création : résultat modifiable, contexte de conversation restauré, sans consommer de création offerte
    inst.resume = function (id) {
      var self = this;
      return get(id).then(function (r) {
        if (!r) return;
        if (self.dialog.open) { self.reset(); self.updateTokens(); } else self.open({ path: 'story', own: true });
        var s = self.s;
        s.path = 'story'; s.saveId = r.id;
        s.sport = r.sport || s.sport; s.niche = r.niche || s.niche;
        s.idea = r.idea || null; s.logoText = r.logoText || null; s.style = r.style || null; s.sides = r.sides || null; s.frontFmt = r.frontFmt || null; s.noText = !!r.noText;
        s.faces = { front: r.faces.front || null, back: r.faces.back || null };
        ['front', 'back'].forEach(function (side) { s.pos[side] = (r.pos && r.pos[side]) || { x: 0.5, y: 0.5, k: 1 }; });
        s.edit = s.faces[r.edit] ? r.edit : (s.faces.front ? 'front' : 'back');
        s.history = r.history || [];
        self._fresh = false;
        if (s.idea) self.user(s.idea);
        self.showResult();
      }).catch(function () {});
    };
  }

  function boot() { document.querySelectorAll('[data-ais]').forEach(enhance); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { setTimeout(boot, 0); });
})();
